import { combineReducers } from "redux";

import { DEFAULT_BUYER_SPLIT, SALE_BUYER_SPLIT } from "constants/actionTypes";

import { offlineCrudReducer } from "lib/reducers";
import { deserializeBuyerSplit as deserializer } from "lib/serializers/buyerSplits";

export default combineReducers({
  default: offlineCrudReducer(DEFAULT_BUYER_SPLIT, {
    deserializer,
  }),

  sale: offlineCrudReducer(SALE_BUYER_SPLIT, { deserializer }),
});
